import React from "react";
import { useActivityNoteStore } from "../../../../config/stores";
import appConfig from "../../../../config/config.json";
import moment from "moment";
import { isEmpty, map } from "lodash";
import { BulletList } from "../../../../components/common/BulletTextArea";
import {
  conceptNoteCellStyle,
  conceptNoteTableStyle,
  conceptNoteTextFields,
  subTitleColumnStyle,
  invitedParticipantColumns,
  INVITED_PARTICIPANTS_LABEL,
} from "./conceptNoteFields";

const PrintConceptNote = () => {
  const activityConceptNotesStore = useActivityNoteStore();
  const { activityNoteDetails } = activityConceptNotesStore;
  return (
    <div>
      <p className="text-center fw-bold h4 text-uppercase">
        Amani Initiative Activity Concept Note
      </p>
      <table
        className="table table-sm table-bordered"
        style={conceptNoteTableStyle}
      >
        <thead>
          <tr>
            <th style={subTitleColumnStyle}>Sub-Titles</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Project Name</td>
            <td className="fw-bold" style={conceptNoteCellStyle}>{activityNoteDetails?.project?.name}</td>
          </tr>
          <tr>
            <td>Funder</td>
            <td className="fw-bold" style={conceptNoteCellStyle}>
              {activityNoteDetails?.project?.donors?.name}
            </td>
          </tr>

          <tr>
            <td>Budget Line</td>
            <td className="fw-bold" style={conceptNoteCellStyle}>{activityNoteDetails?.budgetLine?.name}</td>
          </tr>
          <tr>
            <td>Strategic Plan Priority Input</td>
            <td className="fw-bold" style={conceptNoteCellStyle}>
              {" "}
              {activityNoteDetails?.strategicPlan?.title}
            </td>
          </tr>
          <tr>
            <td>Department/Thematic Area</td>
            <td className="fw-bold" style={conceptNoteCellStyle}>
              {activityNoteDetails?.thematicArea?.thematic_area}
            </td>
          </tr>
          <tr>
            <td>Activity Name</td>
            <td className="fw-bold" style={conceptNoteCellStyle}>
              {activityNoteDetails?.activity?.activity}
            </td>
          </tr>
          <tr>
            <td>Activity Dates</td>
            <td className="fw-bold" style={conceptNoteCellStyle}>
              {activityNoteDetails?.date
                ? moment(activityNoteDetails.date).format("DD/MM/YYYY")
                : ""}
            </td>
          </tr>
          {conceptNoteTextFields.map((field) => (
            <tr key={field.name}>
              <td>{field.label}</td>
              <td style={conceptNoteCellStyle}>
                {field.bulleted ? (
                  <BulletList text={activityNoteDetails?.[field.name]} />
                ) : (
                  activityNoteDetails?.[field.name]
                )}
              </td>
            </tr>
          ))}
          <tr>
            <td>Prepared By</td>
            <td className="fw-bold" style={conceptNoteCellStyle}>
              {activityNoteDetails?.created_by?.first_name}{" "}
              {activityNoteDetails?.created_by?.other_names}
            </td>
          </tr>
          <tr>
            <td>
              Signature
              <div>
                {activityNoteDetails?.created_by?.signature && (
                  <img
                    src={`${appConfig.server_url}${activityNoteDetails?.created_by?.signature}`}
                    alt="signature"
                    width="30"
                    height="15"
                  />
                )}
              </div>
            </td>
            <td className="fw-bold" style={conceptNoteCellStyle}>
              Date:{" "}
              {moment(activityNoteDetails?.created_at).format("DD/MM/YYYY")}
            </td>
          </tr>
          <tr>
            <td>Checked By</td>
            <td className="fw-bold" style={conceptNoteCellStyle}>
              {activityNoteDetails?.checked_by?.first_name}{" "}
              {activityNoteDetails?.checked_by?.other_names}
            </td>
          </tr>
          <tr>
            <td>
              Signature
              <div>
                {activityNoteDetails?.checked_by?.signature && (
                  <img
                    src={`${appConfig.server_url}${activityNoteDetails?.checked_by?.signature}`}
                    alt="signature"
                    width="30"
                    height="15"
                  />
                )}
              </div>
            </td>
            <td>
              Date:{" "}
              {moment(activityNoteDetails?.checked_at).format("DD/MM/YYYY")}
            </td>
          </tr>
          <tr>
            <td>Approved By</td>
            <td>
              {activityNoteDetails?.approved_by?.first_name}{" "}
              {activityNoteDetails?.approved_by?.other_names}
            </td>
          </tr>
          <tr>
            <td>
              Signature
              <div>
                {activityNoteDetails?.approved_by?.signature && (
                  <img
                    src={`${appConfig.server_url}${activityNoteDetails?.approved_by?.signature}`}
                    alt="signature"
                    width="30"
                    height="15"
                  />
                )}
              </div>
            </td>
            <td>
              Date:{" "}
              {moment(activityNoteDetails?.approved_at).format("DD/MM/YYYY")}
            </td>
          </tr>
        </tbody>
      </table>
      <p className="fw-bold">{INVITED_PARTICIPANTS_LABEL}</p>
      <table
        className="table table-sm table-bordered"
        style={conceptNoteTableStyle}
      >
        <thead>
          <tr>
            {invitedParticipantColumns.map((column) => (
              <th key={column.name}>{column.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {isEmpty(activityNoteDetails?.invited_participants) && (
            <tr>
              <td colSpan={invitedParticipantColumns.length}>
                No participants listed
              </td>
            </tr>
          )}
          {map(activityNoteDetails?.invited_participants, (participant, index) => (
            <tr key={index}>
              {invitedParticipantColumns.map((column) => (
                <td key={column.name} style={conceptNoteCellStyle}>
                  {participant?.[column.name]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <p className="fw-bold">Annex</p>
      <p className="fw-bold">
        Annex 1:- Proposed Detailed Activity Agenda or Program
      </p>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Session</th>
            <th>Person Responsible</th>
            <th>Start</th>
            <th>End</th>
          </tr>
        </thead>
        <tbody>
          {activityNoteDetails?.activities?.map((session) => (
            <tr key={session.id}>
              <td>{session.session}</td>
              <td>{session.person_responsible}</td>
              <td>{moment(session.start).format("DD/MM/YYYY HH:mm")}</td>
              <td>{moment(session.end).format("DD/MM/YYYY HH:mm")}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <p className="fw-bold">Annex 2:- Proposed Detailed Activity Budget</p>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Budget Item</th>
            <th>Units</th>
            <th>Unit Cost</th>
            <th>Total Cost</th>
          </tr>
        </thead>
        <tbody>
          {map(activityNoteDetails?.requisitionCostDrivers, (item) => (
            <tr key={item.id}>
              <td>{item.name}</td>
              <td>{item.units}</td>
              <td>UGX {item.unit_cost?.toLocaleString()}</td>
              <td>UGX {item.total_cost?.toLocaleString()}</td>
            </tr>
          ))}
          <tr>
            <td>Total</td>
            <td></td>
            <td></td>
            <td className="fw-bold" style={conceptNoteCellStyle}>
              UGX{" "}
              {activityNoteDetails?.requisitionCostDrivers
                ?.reduce((acc, item) => acc + item.total_cost, 0)
                .toLocaleString()}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default PrintConceptNote;
